import React from "react";
import WealthCalculator from "../components/WealthCalculator";

export default function CalculatorPage() {
  return (
    <div className="container-zelo py-12 md:py-20" data-testid="calculator-page">
      <div className="max-w-2xl mb-12">
        <div className="label-tiny text-brand">Wealth · LRD · Mortgage Calculator</div>
        <h1 className="font-heading text-4xl md:text-5xl font-medium tracking-tight mt-3 text-balance">See exactly how rent compounds.</h1>
        <p className="mt-4 text-neutral-500 text-lg">Plug in your numbers — purchase price, rent, loan terms — and see EMI, net cashflow, and a year-on-year rental projection.</p>
      </div>
      <WealthCalculator />
    </div>
  );
}
